import { useRouter } from 'next/router';
import React from 'react';
import { NoUnderlineAnchor } from '../../shared-styled/typography/Anchors';
import styles from '../../styles/print-media.module.css';
import UniversalLink from '../UniversalLink/UniversalLink';
import { SectionNav, SectionNavItem } from './SectionNavigation.styled';

const SectionNavigation = ({
  urlItems,
  isModifiedSectionNavigationOnPrint,
}) => {
  const router = useRouter();

  return (
    <SectionNav>
      {urlItems.map((el) => {
        const isActive = router
          ? el.url.includes(router.asPath)
          : window.location.path.includes(el.url);

        return (
          <UniversalLink key={el.title} href={el.url} passHref>
            <NoUnderlineAnchor className={!isActive && styles.hideForPrint}>
              <SectionNavItem
                $isActive={isActive}
                $isModifiedSectionNavigationOnPrint={
                  isModifiedSectionNavigationOnPrint
                }
              >
                {el.title}
              </SectionNavItem>
            </NoUnderlineAnchor>
          </UniversalLink>
        );
      })}
    </SectionNav>
  );
};

export default SectionNavigation;
